function RequiredShim() {	
	var self = this;
	var form = document.querySelector('form.product_form');
	
	function html5Validation() {
		// Check if validation supported && not safari
		return (typeof document.createElement('input').checkValidity === 'function') && !(navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0);
	}

	this.validate = function() {
		if(!html5Validation()) {
			console.log('form validating, no html5 validation...');
			var isValid = true;
			var fields = form.querySelectorAll('[required]');
			console.log(fields);
			
			for(var i=0; i<fields.length; i++) {
				var field = fields[i];
				field.classList.remove('error');
				if(!field.value) {
					isValid = false;
					field.classList.add('error');
				}
			}

			if(!isValid) { alert('Please select ' + fields.length + ' colors'); } 	
			
			console.log(isValid);
			return isValid; 

		} else {
			return true;
		}
	}

}

var hex80 = {}
	hex80.shim =  new RequiredShim();
